window._ = require('lodash');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.queryString = require('query-string');

window.Vue = require('vue');

window.Vuex = require('vuex');
Vue.use(Vuex);

window.numeral = require('numeral');
window.numeral.register('locale', 'id', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'rb',
        million: 'jt',
        billion: 'm',
        trillion: 't'
    },
    currency: {
        symbol: 'Rp'
    }
});
window.numeral.locale('id');

window.Vue.prototype.$rupiah = function (value) {
    return numeral(value).format('$ 0,0');
};

window.Vue.prototype.$sixDigitNumber = function (value) {
    return numeral(value).format('000000');
};

window.Vue.use(require('vue-moment'));

import VueCountdown from '@chenfengyuan/vue-countdown';
window.Vue.component(VueCountdown.name, VueCountdown);

import dayjs from 'dayjs'
import 'dayjs/locale/id'
dayjs.locale('id')
window.tanggal = function (date) {
  return dayjs(date).format('D MMMM YYYY')
}